import { useApplicationModals } from "app/common/hooks";
import { useCreateForm } from "app/integration/common/hooks";
import * as Yup from "yup";
import api from "app/integration/api";
import { ModalMolecule } from "app/components/molecules/modal";
import { useCollector } from "app/integration/common/hooks";
import { Formik, FieldArray, getIn } from "formik";
import { InputMolecule } from "app/components/molecules/form";
import { InputLabel } from "app/components/atoms/form";
import { Button, DottedOutlineButton } from "app/components/atoms/button";
import { ClosableCard } from "app/components/atoms/card";
import AppModals from ".";
import {
  SelectMolecule,
  SelectSearchMolecule,
} from "app/components/molecules/select";
import { useEffect } from "react";

function CreateCustomerModal({ onSuccess = () => {} }) {
  const { showStates, closeModal } = useApplicationModals();

  const handleClose = () => closeModal("customer.create");
  const handleSuccess = () => {
    closeModal("customer.create");
    onSuccess();
  };

  var isError = false;

  const { openModal, setPayloads } = useApplicationModals();
  const [states] = useCollector({
    modelName: "rajaOngkir",
    methodName: "province",
  });

  const [cities, setCities, cityLoader, collectCities] = useCollector({
    modelName: "rajaOngkir",
    methodName: "city",
  });

  const [subDistricts, setSubDistricts, subDistrictLoader, collectSubDistrict] =
    useCollector({
      modelName: "rajaOngkir",
      methodName: "subdistrict",
    });

  const { initialValues, validationSchema, onSubmit } = useCreateForm({
    initialValues: {
      id: null,
      firstName: "",
      middleName: "",
      lastName: "",
      nickName: "",
      phone: "",
      email: "",
      customer_address: [],
    },
    validationSchema: Yup.object().shape({
      firstName: Yup.string().required("Nama Customer harus diisi"),
      middleName: Yup.string(),
      lastName: Yup.string(),
      nickName: Yup.string(),
      phone: Yup.string(),
      email: Yup.string(),
      first_bank: Yup.string(),
      second_bank: Yup.string(),
      third_bank: Yup.string(),
      customer_address: Yup.array().of(
        Yup.object().shape({
          desc: Yup.string().required("Alamat harus diisi"),
          // state_id: Yup.number(),
          // state_name: Yup.string(),
          // city_id: Yup.number(),
          // city_name: Yup.string(),
          // district_id: Yup.number(),
          // district_name: Yup.string(),
          // sub_district_id: Yup.number(),
          // sub_district_name: Yup.string(),
          zipcode: Yup.string(),
        })
      ),
    }),
    onSubmit: async (values) => {
      await api.customer
        .store(
          values.firstName,
          values.middleName,
          values.lastName,
          values.nickName,
          values.first_bank,
          values.second_bank,
          values.third_bank,
          values.email,
          values.phone,
          values.customer_address.map((address) => ({
            desc: address.desc,
            state_id: address.state_id,
            state_name: address.state_name,
            city_id: address.city_id,
            city_name: address.city_name,
            district_id: address.district_id,
            district_name: address.district_name,
            sub_district_id: address.sub_district_id,
            sub_district_name: address.sub_district_name,
            zipcode: address.zipcode,
          }))
        )
        .catch((error) => {
          // console.log("eror: ", error);
          setPayloads("errorMessage.view", {
            title: "Tambah Customer Error",
            message:
              error?.response.status === 400
                ? "Gagal tambah customer karena nomor HP yang sama telah terdaftar pada database customer."
                : error?.response?.data?.message,
          });
          isError = true;
          openModal("errorMessage.view");
          // console.log("delete error: ", error?.response?.data?.message);
        });
    },
    onSuccess: () => {
      if (!isError) {
        handleSuccess();
      }
    },
  });

  return (
    <ModalMolecule
      show={showStates["customer.create"]}
      title="Tambah Customer"
      onClose={handleClose}
    >
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-4">
              <InputMolecule testId="modal-create-customer-firstname-input"
                label="Nama Depan"
                type="text"
                name="firstName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstName}
                errorMessage={
                  errors.firstName && touched.firstName && errors.firstName
                }
                required
              />
              <InputMolecule testId="modal-create-customer-middlename-input"
                label="Nama Tengah"
                type="text"
                name="middleName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.middleName}
                errorMessage={
                  errors.middleName && touched.middleName && errors.middleName
                }
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <InputMolecule testId="modal-create-customer-lastname-input"
                label="Nama Belakang"
                type="text"
                name="lastName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.lastName}
                errorMessage={
                  errors.lastName && touched.lastName && errors.lastName
                }
              />
              <InputMolecule testId="modal-create-customer-nickname-input"
                label="Nama Panggilan"
                type="text"
                name="nickName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.nickName}
                errorMessage={
                  errors.nickName && touched.nickName && errors.nickName
                }
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <InputMolecule testId="modal-create-customer-email-input"
                label="Email"
                type="text"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                errorMessage={errors.email && touched.email && errors.email}
              />
              <InputMolecule testId="modal-create-customer-phone-input"
                label="No. HP"
                type="text"
                name="phone"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.phone}
                errorMessage={errors.phone && touched.phone && errors.phone}
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <InputMolecule testId="modal-create-customer-first-bank-input"
                label="Nama Bank"
                type="text"
                name="first_bank"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.first_bank}
                errorMessage={
                  errors.first_bank && touched.first_bank && errors.first_bank
                }
              />
              <InputMolecule testId="modal-create-customer-second-bank-input"
                label="Nomor Rekening"
                type="text"
                name="second_bank"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.second_bank}
                errorMessage={
                  errors.second_bank &&
                  touched.second_bank &&
                  errors.second_bank
                }
              />

              {/* <InputMolecule testId="modal-create-customer-third-bank-input"
                label="Account Bank 3"
                type="text"
                name="third_bank"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.third_bank}
                errorMessage={
                  errors.third_bank && touched.third_bank && errors.third_bank
                }
              /> */}
            </div>
            <div>
              <hr className="my-5" />
            </div>
            <div>
              <InputLabel required>Alamat</InputLabel>
              <FieldArray name="customer_address">
                {(arrayHelpers) => (
                  <div className="space-y-2">
                    {values?.customer_address?.map((address, addressKey) => (
                      <ClosableCard
                        key={addressKey}
                        onClose={() => arrayHelpers.remove(addressKey)}
                      >
                        <div className="space-y-2 p-2">
                          <InputMolecule testId="modal-create-customer-customer-address-desc-input"
                            label="Alamat Lengkap"
                            type="text"
                            name={`customer_address[${addressKey}].desc`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={address.desc}
                            errorMessage={
                              getIn(
                                errors,
                                `customer_address[${addressKey}].desc`
                              ) &&
                              getIn(
                                touched,
                                `customer_address[${addressKey}].desc`
                              ) &&
                              getIn(
                                errors,
                                `customer_address[${addressKey}].desc`
                              )
                            }
                            required
                          />
                          <SelectSearchMolecule testId="modal-create-customer-customer-address-state-id-select"
                            label="Provinsi"
                            name={`customer_address[${addressKey}].state_id`}
                            options={states?.map((state) => ({
                              value: state.province_id,
                              label: state.province,
                            }))}
                            absolute={true}
                            onChange={async (e) => {
                              values.customer_address[
                                `${addressKey}`
                              ].state_name = states.filter(
                                (i) => i.province_id == e.target.value
                              )[0]["province"];
                              handleChange(e);
                              await collectCities({ province: e.target.value });
                            }}
                            onBlur={handleBlur}
                            value={address.state_id}
                            errorMessage={
                              getIn(
                                errors,
                                `customer_address[${addressKey}].state_id`
                              ) &&
                              getIn(
                                touched,
                                `customer_address[${addressKey}].state_id`
                              ) &&
                              getIn(
                                errors,
                                `customer_address[${addressKey}].state_id`
                              )
                            }
                            required
                          />
                          <SelectSearchMolecule testId="modal-create-customer-customer-address-city-id-select"
                            label="Kota"
                            name={`customer_address[${addressKey}].city_id`}
                            options={cities?.map((city) => ({
                              value: city.city_id,
                              label: city.city_name,
                            }))}
                            absolute={true}
                            onChange={async (e) => {
                              values.customer_address[
                                `${addressKey}`
                              ].city_name = cities.filter(
                                (i) => i.city_id == e.target.value
                              )[0]["city_name"];
                              handleChange(e);
                              await collectSubDistrict({ city: e.target.value });
                            }}
                            onBlur={handleBlur}
                            value={address.city_id}
                            errorMessage={
                              getIn(
                                errors,
                                `customer_address[${addressKey}].city_id`
                              ) &&
                              getIn(
                                touched,
                                `customer_address[${addressKey}].city_id`
                              ) &&
                              getIn(
                                errors,
                                `customer_address[${addressKey}].city_id`
                              )
                            }
                            required
                          />
                          <SelectSearchMolecule testId="modal-create-customer-customer-address-district-id-select"
                            label="Kecamatan"
                            name={`customer_address[${addressKey}].district_id`}
                            options={subDistricts?.map((subDistrict) => ({
                              value: subDistrict.subdistrict_id,
                              label: subDistrict.subdistrict_name,
                            }))}
                            absolute={true}
                            onChange={(e) => {
                              values.customer_address[
                                `${addressKey}`
                              ].district_name = subDistricts.find(
                                (i) => i.subdistrict_id == e.target.value
                              )?.subdistrict_name;
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            value={address.district_id}
                            errorMessage={
                              getIn(
                                errors,
                                `customer_address[${addressKey}].district_id`
                              ) &&
                              getIn(
                                touched,
                                `customer_address[${addressKey}].district_id`
                              ) &&
                              getIn(
                                errors,
                                `customer_address[${addressKey}].district_id`
                              )
                            }
                            required
                          />
                          <InputMolecule testId="modal-create-customer-customer-address-sub-district-name-input"
                            label="Kelurahan"
                            type="text"
                            name={`customer_address[${addressKey}].sub_district_name`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={address.sub_district_name}
                            errorMessage={
                              getIn(
                                errors,
                                `customer_address[${addressKey}].sub_district_name`
                              ) &&
                              getIn(
                                touched,
                                `customer_address[${addressKey}].sub_district_name`
                              ) &&
                              getIn(
                                errors,
                                `customer_address[${addressKey}].sub_district_name`
                              )
                            }
                          />
                          <InputMolecule testId="modal-create-customer-customer-address-zipcode-input"
                            label="Kode Pos"
                            type="text"
                            name={`customer_address[${addressKey}].zipcode`}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={address.zipcode}
                            errorMessage={
                              getIn(
                                errors,
                                `customer_address[${addressKey}].zipcode`
                              ) &&
                              getIn(
                                touched,
                                `customer_address[${addressKey}].zipcode`
                              ) &&
                              getIn(
                                errors,
                                `customer_address[${addressKey}].zipcode`
                              )
                            }
                          />
                        </div>
                      </ClosableCard>
                    ))}
                    <div>
                      <div className="my-8">
                        <DottedOutlineButton testId="modal-create-customer-tambah-alamat-button"
                          type="button"
                          onClick={(e) =>
                            arrayHelpers.push({
                              address: "",
                              state: "",
                              city: "",
                              district: "",
                              subDistrict: "",
                              shipmentCostCategoryId: null,
                            })
                          }
                        >
                          Tambah Alamat
                        </DottedOutlineButton>
                      </div>
                    </div>
                  </div>
                )}
              </FieldArray>
            </div>
            <div>
              <hr className="my-5" />
            </div>
            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-create-customer-submit-button" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Menyimpan...' : 'Tambah Customer'}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}

export default CreateCustomerModal;
